import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import React, { useContext, useEffect, useState } from "react";
import styles from "./ZipcodeLookup.module.scss";
import AutocompleteInput from "Components/FormControl/Autocomplete/Autocomplete";
import { DAY_ORDER, DEFAULT_STORE_ID } from "Helpers/Constants";
import { convertDateTime } from "Helpers/date";
import { AppContext } from "Context/AppContext";
import { getAllZipcodeAndStoreList } from "api/order";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ZipcodeLookup = ({ showModal, pageTitle, handleCancelClick }) => {
  const [storeInfo, setStoreInfo] = useState(null);
  const [storeId, setStoreId] = useState(null);
  const [zipcode, setZipcode] = useState("");
  const [error, setError] = useState(false);
  const [zipcodes, setZipcodes] = useState([]);
  const [stores, setStores] = useState([]);
  const { setIsLoading } = useContext(AppContext);
  const [openOnFocus, setOpenOnFocus] = useState(false);

  // Fetches the list of all zipcodes and stores from the API and updates local state
  const getZipcodeAndStoreList = async () => {
    const resp = await getAllZipcodeAndStoreList();
    if (resp.data && resp.status === 200) {
      let tempZipcodes = resp.data?.data?.zipcodeData?.rows || [];
      const tempStores = resp.data?.data?.storeList?.rows || [];
      tempZipcodes = tempZipcodes.map((zipcode) => {
        const storeDetails = tempStores.find(
          (store) => store.id === zipcode.store_id
        );
        return {
          ...zipcode,
          // title: zipcode.zip_code,
          title: zipcode.zip_code + " - " + storeDetails?.title,
        };
      });
      setZipcodes(tempZipcodes); // Update state with fetched zipcode data
      setStores(tempStores); // Update state with fetched store list
    }
  };

  // On component mount, fetch the zipcode and store list
  useEffect(() => {
    getZipcodeAndStoreList();
  }, []);

  const getStoreInfo = () => {
    setIsLoading(true);
    if (storeId && storeId !== null) {
      const store = stores.find((store) => store.id === storeId);
      setStoreInfo(store);
    } else if (zipcode && zipcode !== null && zipcode.length === 5) {
      const zipcodeData = zipcodes.find(
        (zipcodeValue) => zipcodeValue.zip_code === zipcode
      );
      if (zipcodeData) {
        const store = stores.find((store) => store.id === zipcodeData.store_id);
        setStoreInfo(store);
      } else {
        const store = stores.find((store) => store.id === DEFAULT_STORE_ID);
        setStoreInfo(store);
      }
    } else {
      setError(true);
    }
    setIsLoading(false);
  };

  // Handles validation of the zipcode input field
  const handleValidation = (params) => {
    return {
      ...params.inputProps,
      inputMode: "numeric",
      pattern: "[0-9]*",
      maxLength: 5,
      onKeyPress: (e) => {
        if (!/[0-9]/.test(e.key)) {
          e.preventDefault();
        }
      },
    };
  };

  // Handles the logic to set the store info to null when the zipcode is not valid
  useEffect(() => {
    if (zipcode.length !== 5) {
      setStoreInfo(null);
    }
  }, [zipcode]);

  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        onClose={handleCancelClick}
        classes={{
          paper: styles.modalDialog,
        }}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogContent
          className={`${styles.modalContent} px-0 py-0`}
          style={{
            height: openOnFocus ? "450px" : "auto",
          }}
        >
          <div className={`text-center`}>
            <h5 className={`my-1 mt-5 text-center ${styles.modalTitle}`}>
              {pageTitle}
            </h5>
            <div className={`${styles.zipcodeLookupWrapper}`}>
              <div className={`${styles.zipcodeInputWrapper}`}>
                <div className={` ${styles.zipcodeInput} ${error && "pt-4"}`}>
                  <AutocompleteInput
                    label="Search ZIP Code or Store"
                    value={zipcode}
                    required={true}
                    submitStatus={false}
                    onChangeParent={(data) => {
                      setStoreId(data.store_id);
                      if(zipcode.length === 5){
                        getStoreInfo();
                      }
                    }}
                    onChangeParentManual={(data) => {
                      if(data.length > 5){
                        //85331 - North Scottsdale
                        const tempZipcode = data.split(" - ")[0];
                        setZipcode(tempZipcode);
                      }
                      else{
                        setZipcode(data);
                      }
                      setError(false);
                      if (data.length === 5) {
                        setStoreInfo(null);
                      }
                    }}
                    listData={zipcodes || []}
                    id="zipcodeSearching"
                    isAllowValidate={true}
                    handleValidation={handleValidation}
                    customAutocompletePaperClass={
                      styles.customAutocompletePaper
                    }
                    isOpenOnFocus={true}
                    setOpenOnFocus={setOpenOnFocus}
                  />
                </div>
                <div style={{ textAlign: "left" }}>
                  <span style={{ color: "red" }}>
                    {error &&
                      zipcode?.length !== 5 &&
                      "Please enter a valid zipcode"}
                  </span>
                </div>
              </div>
              <div className=" mt-2 mb-3" onClick={() => getStoreInfo()}>
                <span className="btn gray-btn d-inline-block mt-5 mb-5 mr-2 mt-5 cursor-pointer">
                  Get Info
                </span>
              </div>
            </div>
          </div>
          {storeInfo && (
            <div className={`mt-0 ml-3 ${styles.modalBody}`}>
              <div className="text-center" style={{ fontSize: "25px" }}>
                Store Information
                <span style={{ fontSize: "25px", fontWeight: "bold" }}>
                  {` - ${storeInfo?.title}`}
                </span>
              </div>
              <hr />
              <div className={`${styles.storeInfoWrapper}`}>
                <div className="">
                  <p style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Store Address
                  </p>
                  <p style={{ fontSize: "18px" }}>{`${storeInfo.address1}`}</p>
                  <p
                    style={{ fontSize: "18px" }}
                  >{`${storeInfo.city} ${storeInfo.state} ${storeInfo.zip}`}</p>
                  <p style={{ fontSize: "18px", paddingTop: "10px" }}>
                    Phone <span>{storeInfo?.local_phone1}</span>
                  </p>
                  <p style={{ fontSize: "18px" }}>
                    Email <span>{storeInfo?.email_id_main}</span>
                  </p>
                </div>
                <div className={`${styles.storeOperatingHours}`}>
                  <p style={{ fontWeight: "bold", fontSize: "20px" }}>
                    Store Operating Hours
                  </p>
                  <table style={{ width: "100%", fontSize: "18px" }}>
                    <tbody>
                      {storeInfo?.store_settings_openclose_times
                        ?.sort((a, b) => DAY_ORDER[a.key] - DAY_ORDER[b.key])
                        ?.map((storeSetting, i) => (
                          <tr key={i}>
                            <td
                              style={{
                                paddingBottom: "1rem",
                                paddingRight: "1rem",
                              }}
                            >
                              {storeSetting.key}
                            </td>
                            <td
                              style={{
                                paddingBottom: "1rem",
                                paddingRight: "1rem",
                              }}
                            >
                              {storeSetting.is_closed === 1
                                ? "Closed"
                                : `${convertDateTime(
                                    storeSetting.open_value,
                                    "format2",
                                    "hh:mm a",
                                    "hh:mm:ss",
                                    storeInfo?.timezone,
                                    "UTC"
                                  )}`}
                            </td>
                            <td
                              style={{
                                paddingBottom: "1rem",
                                paddingRight: "1rem",
                              }}
                            >
                              {" - "}
                            </td>
                            <td
                              style={{
                                paddingBottom: "1rem",
                                paddingRight: "1rem",
                              }}
                            >
                              {storeSetting.is_closed === 1
                                ? "Closed"
                                : `${convertDateTime(
                                    storeSetting.close_value,
                                    "format2",
                                    "hh:mm a",
                                    "hh:mm:ss",
                                    storeInfo?.timezone,
                                    "UTC"
                                  )}`}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ZipcodeLookup;
